import { render, staticRenderFns } from "./AddAmcList.vue?vue&type=template&id=c7aef6ca&scoped=true"
import script from "./AddAmcList.vue?vue&type=script&lang=js"
export * from "./AddAmcList.vue?vue&type=script&lang=js"
import style0 from "./AddAmcList.vue?vue&type=style&index=0&id=c7aef6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aef6ca",
  null
  
)

export default component.exports